import { render, staticRenderFns } from "./modules1.vue?vue&type=template&id=50836fe4&scoped=true"
import script from "./modules1.vue?vue&type=script&lang=js"
export * from "./modules1.vue?vue&type=script&lang=js"
import style0 from "./modules1.vue?vue&type=style&index=0&id=50836fe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50836fe4",
  null
  
)

export default component.exports